<template>
  <div
      class="question-multipart-wrapper d-flex flex-wrap align-items-end"
  >
    <QuestionBase
        :question="question"
        :valid="!!data"
        :errors="[...serverErrors, ...jsErrors]"
    >
      <InputDateSplit
          v-if="data || data === null"
          v-model="data" :db="db"
          :args="args"
          :skipped="skipped"
          @skipped="skipped=$event"
          @serverErrors="serverErrors=$event"
          @jsErrors="jsErrors=$event"
      />
    </QuestionBase>
  </div>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import {saveHelpers} from "@/views/questionnaires/saveHelpers";

import QuestionBase from "../../../QuestionBase";
import InputDateSplit from "../../../inputs/InputDateSplit";

export default {
  name: 'PregnantDate',
  mixins: [saveHelpers, questionLoadHelpers],
  components: {
    InputDateSplit,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'What is the approximate due date?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'profilePregnantDueDate'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>